export const getLinkName = (link: string) => {
    const splitLink = link.split('/');
    return splitLink[splitLink.length - 1]
}